export const jobStatuses: Readonly<any> = {
    0: { Text: 'Created', Class: 'status-0' },
    1: { Text: 'Running', Class: 'status-1' },
    2: { Text: 'Cancelled', Class: 'status-2' },
    3: { Text: 'Failed', Class: 'status-3', Icon: 'dbm-redCircle' },
    4: { Text: 'Waiting For User', Class: 'status-4' },
    5: { Text: 'Complete', Class: 'status-5', Icon: 'dbm-greenCircle' },
    6: { Text: 'Warning', Icon: 'dbm-orangeCircle' },
    7: { Text: 'Aborting' }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/jobStatuses.ts